import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSplitViewStore = defineStore('splitView', () => {
  const isSplitMode = ref(false)
  const splitContent = ref(null)

  function enableSplitMode(content = null) {
    isSplitMode.value = true
    splitContent.value = content
  }

  function disableSplitMode() {
    isSplitMode.value = false
    splitContent.value = null
  }

  function setSplitContent(content) {
    splitContent.value = content
  }

  return {
    isSplitMode,
    splitContent,
    enableSplitMode,
    disableSplitMode,
    setSplitContent
  }
}) 